import { extractQueryState } from "@shared/utils/extractQueryState";
import { useQuery } from "@tanstack/react-query";
import { getChatApiClient } from "@shared/apis/sidekick/api-factories";
import { ListThreadsResponse } from "@shared/apis/sidekick/generated";

const queryKey = "threads";

type Props = {
  onSuccess: (data: ListThreadsResponse) => void;
  enabled?: boolean;
};

export const useGetThreads = (props?: Props) => {
  const { onSuccess, enabled = true } = props || {};
  const chatApi = getChatApiClient();
  const customerInitSession = useQuery({
    queryKey: [queryKey],
    queryFn: async () => {
      try {
        const response = await chatApi.chatControllerListThreads();
        onSuccess?.(response);
        return response;
      } catch (error) {
        console.error("Failed to get threads.", error);
        throw error;
      }
    },
    enabled,
    retry: false,
    refetchInterval: false,
    refetchOnWindowFocus: false,
  });

  return extractQueryState(customerInitSession);
};
